"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.isFormikErrorMeterReadingRegisterTypes = exports.default = void 0;
var _react = _interopRequireWildcard(require("react"));
var _reactSharedUiNext = require("@eon-funke/react-shared-ui-next");
var _MeterNumberValidationHelpers = _interopRequireDefault(require("../../../../../utils/MeterNumberValidationHelpers"));
var _InputValidationHelper = require("../../../../../utils/InputValidationHelper");
var _EnergyTypeHelper = require("../../../../../utils/EnergyTypeHelper");
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != _typeof(e) && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t in e) { "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]); } return f; })(e, t); }
var isFormikErrorMeterReadingRegisterTypes = exports.isFormikErrorMeterReadingRegisterTypes = function isFormikErrorMeterReadingRegisterTypes(x) {
  return x !== undefined;
};
var MeterRegisterInput = function MeterRegisterInput(props) {
  var _formErrors$index, _currentRegister$erro;
  var register = props.register,
    registerAPIErrors = props.registerAPIErrors,
    registerPlaceholder = props.registerPlaceholder,
    lastMeterValueLabel = props.lastMeterValueLabel,
    formikProps = props.formikProps,
    formikIdentifier = props.formikIdentifier,
    loggedIn = props.loggedIn,
    index = props.index,
    unit = props.unit;
  var values = formikProps.values,
    handleChange = formikProps.handleChange,
    errors = formikProps.errors,
    setFieldValue = formikProps.setFieldValue;
  var formErrors = isFormikErrorMeterReadingRegisterTypes(errors.registers) ? errors.registers : {};
  var currentRegister = values.registers[index];
  var touched = currentRegister.readingResult !== undefined;
  var errorMessage = (_formErrors$index = formErrors[index]) === null || _formErrors$index === void 0 ? void 0 : _formErrors$index.readingResult;
  var errorApiCode = (_currentRegister$erro = currentRegister.errorCode) === null || _currentRegister$erro === void 0 ? void 0 : _currentRegister$erro.split('.').pop();
  var errorApiMessage = errorApiCode && registerAPIErrors[errorApiCode];
  var errorOutput = errorApiCode && errorApiMessage || errorMessage;
  var errorState = touched && (errorMessage !== undefined || errorApiMessage !== undefined && currentRegister.readingNoteNumber === undefined);
  function resetValues() {
    if (currentRegister.possibleReadingNotes !== undefined || currentRegister.errorCode !== undefined || currentRegister.readingNoteNumber !== undefined) {
      setFieldValue("".concat(formikIdentifier, ".possibleReadingNotes"), undefined);
      setFieldValue("".concat(formikIdentifier, ".errorCode"), undefined);
      setFieldValue("".concat(formikIdentifier, ".readingNoteNumber"), undefined);
    }
  }
  (0, _react.useEffect)(function () {
    return resetValues();
  }, [currentRegister.readingResult]);
  return /*#__PURE__*/_react.default.createElement("div", {
    className: "form-group",
    key: "form".concat(index)
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: loggedIn ? 'loggedin-meter-form__input-group' : 'ano-meter-form__input-group'
  }, /*#__PURE__*/_react.default.createElement(_reactSharedUiNext.TextInput, {
    name: "".concat(formikIdentifier, ".readingResult"),
    type: "text",
    id: register.registerNumber,
    label: registerPlaceholder,
    qaId: register.obis,
    onChange: handleChange,
    inputState: (0, _InputValidationHelper.setInputState)(errorState, touched),
    errorMessage: touched && errorOutput
  }), /*#__PURE__*/_react.default.createElement("strong", {
    className: loggedIn ? 'loggedin-meter-form__last-values' : 'ano-meter-form__last-values'
  }, "\n          ".concat(lastMeterValueLabel || '', "\n          ").concat(_MeterNumberValidationHelpers.default.getFormattedValue(register.lastReadingResult), "\n          ").concat((0, _EnergyTypeHelper.getPowerUnitLabel)(unit), "\n          "))));
};
var _default = exports.default = MeterRegisterInput;